<script>
  import CommonFormElementMixin from './mixins/CommonFormElement'
  import { mdbInput } from 'mdbvue'
  export default {
    mixins: [CommonFormElementMixin],
    computed: {
      isValid () {
        return !this.error || this.error === null
      },
      invalidFeedback () {
        if (!this.error) return ''
        return this.$t('validation.' + Object.keys(this.error)[0])
      }
    },
    components: {
      mdbInput
    }
  }
</script>

<template>
  <mdb-input
    :label="label"
    v-model="localValue"
    :customValidation="isFormSubmitted"
    :isValid="isValid"
    :invalidFeedback="invalidFeedback"
    type="text"
  />
</template>
